module.exports = __webpack_public_path__ + "static/media/tp5.525f91c3.jpg";